import { REGEX } from "../../constants/regex";
import LoadingButton from "../common/LoadingButton";
import InfoPanel from "./InfoPanel";

export default function FindIdForm({
  emailValue,
  codeValue,
  onEmailChange,
  onCodeChange,
  onSend,
  onSubmit,
  t,
  countdown,
  emailErrorType,
  codeErrorType,
  onCodeBlur,
  codeSent,
  emailPlaceholder,
  codeSentMessage,
  codeSentEmail,
}) {
  const isReqErr = emailErrorType === 'required';
  const isFmtErr = emailErrorType === 'format';
  const isCodeInvalid = codeErrorType === 'invalid';

  const CODE_LENGTH = 6;
  const isEmailValid = !!emailValue.trim() && REGEX.EMAIL.test(emailValue);

  return (
    <div className="id-panel w-full flex flex-column gap-2">
      <div className="form-field">
        <label htmlFor="find-id-email" className="keduall-typography text-16-normal-400 required">
          {t.findIdEmailLabel}
        </label>
        <div className="input-row flex gap-3">
          <input
            id="find-id-email"
            type="email"
            maxLength={254}
            placeholder={emailPlaceholder}
            className={
              `keduall-form form-input-default-filled-large flex-1 keduall-typography text-16-normal-400 find-id-email`
              + (emailErrorType ? ' invalid' : '')
            }
            value={emailValue}
            onChange={e => onEmailChange(e.target.value)}
          />
          <LoadingButton
            onClick={onSend}
            disabled={countdown > 0 || !isEmailValid || codeSent}
            label={countdown > 0 ? t.resendCodeButtonLabel : t.findIdSendCodeButtonLabel}
            className="find-id-send-code keduall-buttons button-outlined-default-normal-secondary keduall-typography text-16-semibold-600"
          />
        </div>

        <div className="help">
          {isReqErr && (
            <small className="keduall-typography text-danger-txt text-14-normal-400">
              {t.findIdEmailRequiredLabel || 'This field is required'}
            </small>
          )}
          {isFmtErr && (
            <small className="keduall-typography text-danger-txt text-14-normal-400">
              {t.findIdEmailFormatInvalidLabel || 'Invalid email format'}
            </small>
          )}
        </div>
      </div>

      {codeSent && (
        <>
          <div className="form-field mt-4">
            <label htmlFor="find-id-code" className="keduall-typography text-16-normal-400 required">
              {t.findIdCodeLabel}
            </label>
            <input
              id="find-id-code"
              type="text"
              maxLength={CODE_LENGTH}
              className={
                "find-id-code keduall-form form-input-default-filled-large w-full keduall-typography text-16-normal-400"
                + (isCodeInvalid ? ' invalid' : '')
              }
              value={codeValue}
              onChange={e => onCodeChange(e.target.value)}
              onBlur={onCodeBlur}
            />
            <div className="help">
              {isCodeInvalid && (
                <small className="keduall-typography text-danger-txt text-14-normal-400">
                  {t.findIdCodeInvalidLabel || 'Invalid verification code'}
                </small>
              )}
            </div>
          </div>

          <div className="flex gap-2 actions id-actions">
            <LoadingButton
              onClick={onSubmit}
              label={t.findIdSubmitButtonLabel}
              disabled={
                !isEmailValid
                || codeValue.trim().length !== CODE_LENGTH
                || isCodeInvalid
              }
              className="keduall-buttons button-filled-default-large-primary flex-1 text-white-txt keduall-typography heading-h6-semibold-600"
            />
          </div>

          {/* Email-sent notification sits BELOW the submit button (Figma 648-13206). */}
          {codeSentMessage && (
            <InfoPanel message={codeSentMessage} boldText={codeSentEmail} show />
          )}

          {countdown > 0 && (
            <small className="keduall-typography heading-h6-normal-400 text-default-txt block text-center mt-3">
              {t.resendTimerText.replace('{0}', countdown)}
            </small>
          )}
        </>
      )}
    </div>
  );
}
